import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/showactgoodlist',
			name: 'Showactgoodlist',
			component: resolve => require(['@/components/Showactgoodlist'], resolve),
			children:[
				{
					path: 'showactgoods',
					component: resolve => require(['@/components/Showactgoods'], resolve),
				}
			]
		},
		{
			path: '/showactmy',
			name: 'Showactmy',
			component: resolve => require(['@/components/Showactmy'], resolve),
			children:[
				{
					path: 'showactmyorder',
					//name: 'MyOrder',
					component: resolve => require(['@/components/Showactmyorder'], resolve),
					children:[
						{
							path: 'showactorderdetail',
							component: resolve => require(['@/components/Showactorderdetail'], resolve),
						}
					]
				},
				{
					path: 'showacthistory',
					component: resolve => require(['@/components/Showacthistory'], resolve),
				}
			]

		},
		{
			path: '/showactadresslist',
			name: 'ShowactadressList',
			component: resolve => require(['@/components/ShowactadressList'], resolve),
		},
		{
			path: '/showactadressedit',
			name: 'ShowactAdressEdit',
			component: resolve => require(['@/components/Showactadressedit'], resolve),
		},
		{
			path: '/showactindex',
			name: 'Showactindex',
			component: resolve => require(['@/components/Showactindex'], resolve),
		},{
			path: '/showactexchange',
			name: 'ShowActxchange',
			component: resolve => require(['@/components/ShowActxchange'], resolve),
		},
		{
			path: '/showactqrcode',
			name: 'showactqrcode',
			component: resolve => require(['@/components/Showactqrcode'], resolve),
		},
		{
			path: '/showactcartindex',
			name: 'Showactcartindex',
			component: resolve => require(['@/components/Showactcartindex'], resolve),
			children:[
				{
					path: 'showactgoods',
					component: resolve => require(['@/components/Showactgoods'], resolve),
				},
				{
					path: 'showactcartcheck',
					component: resolve => require(['@/components/Showactcartcheck'], resolve),
					children:[
						{
							path: 'showactadresslist',
							component: resolve => require(['@/components/ShowactadressList'], resolve),
						},
						{
							path: 'showactadressedit',
							component: resolve => require(['@/components/Showactadressedit'], resolve),
						},
					]
				}
			]
		},
		{
			path: '/',
			name: 'ShowactNone',
			// component: resolve => require(['@/components/ShowactNone'], resolve),
			component: resolve => require(['@/components/ShowActxchange'], resolve),
		},
		{
			path: '/settoken',
			name: 'SetToken',
			component: resolve => require(['@/components/SetToken'], resolve),
		},
	]
})
